<template>
	<form @submit.prevent="createItinerary()">
		<div class="row">
			<div
				:class="
					leadPackage
						? 'col-sm-12'
						: masterStore.state.editBool
						? 'col-sm-12'
						: 'col-sm-8'
				"
			>
				<h4 class="mb-5 text-dark">{{ name }} Itinerary</h4>
				<div class="form-group col-sm-12 mb-5">
					<div
						v-for="count in data.itineraryCount"
						:key="`${count}-itinerary`"
						class="row"
					>
						<Itinerary
							:key="count"
							:id="count"
							:defaultData="
								data.editItineraryData.length &&
								data.editItineraryData.length > count - 1
									? data.editItineraryData[count - 1]
									: ''
							"
							:leadPackage="leadPackage"
							@formError="disableForm"
							@formSuccess="enableForm"
						/>
					</div>
					<div
						v-if="
							leadPackage ? false : masterStore.state.editBool ? false : true
						"
						class="form-group col-sm-6 mt-2"
						:class="formState.disable ? 'cursor-disabled' : 'cursor-pointer'"
					>
						<BaseButton
							class="btn btn-primary form-control form-control-lg"
							type="submit"
							label="Save"
							:disabled="formState.disable"
							:loading="formState.isLoading"
						/>
					</div>
				</div>
			</div>
			<div
				v-if="leadPackage ? false : masterStore.state.editBool ? false : true"
				class="col-sm-4 px -4"
			>
				<h4 class="text-dark">Global Trip Holidays</h4>
				<p class="text-dark">
					Contacts are your customers you interact with in pursuit of a business
					opportunity.
				</p>
			</div>
		</div>
	</form>
</template>
<script>
	import { reactive, inject } from "vue";
	import API from "@/config/api";
	import toast from "@/config/toast";
	import BaseButton from "./BaseButton";
	import Itinerary from "@/components/Itinerary";

	export default {
		name: "CreateItinerary",
		props: {
			name: { type: String, default: "Create" },
			count: { type: Number, default: 0 },
			leadPackage: { type: Boolean, default: false },
			defaultData: { type: Array, default: [] },
		},
		components: {
			Itinerary,
			BaseButton,
		},
		emits: ["updateItinerary"],
		setup: (props, { emit }) => {
			const packageEditState = inject("packageEditState");
			const masterStore = inject("masterStore");

			const data = reactive({
				itineraryDayWise: [],
				itineraryCount: [],
				editItineraryData: [],
			});

			if (!props.leadPackage) {
				data.itineraryDayWise =
					packageEditState.state.data?.itineraryDayWise || [];
				data.editItineraryData =
					packageEditState.state.data?.itineraryDayWise || [];
			} else {
				let itinerary = [...props.defaultData];
				itinerary = itinerary.sort(dynamicSort("day"));

				data.itineraryDayWise = [...itinerary];
				data.editItineraryData = [...itinerary];
			}

			function dynamicSort(property) {
				let sort_order = 1;

				return function (a, b) {
					// a should come before b in the sorted order
					if (a[property] < b[property]) {
						return -1 * sort_order;
						// a should come after b in the sorted order
					} else if (a[property] > b[property]) {
						return 1 * sort_order;
						// a and b are the same
					} else {
						return 0 * sort_order;
					}
				};
			}

			// if (
			// 	(packageEditState.state.activeComponent === "edit" &&
			// 		packageEditState.state.data?.itinerary &&
			// 		packageEditState.state.data?.itineraryDayWise.length) ||
			// 	(packageEditState.state.editBool &&
			// 		packageEditState.state.data?.itinerary &&
			// 		packageEditState.state.data?.itineraryDayWise.length)
			// ) {
			// 	data.editItineraryData = [...packageEditState.state.data.itineraryDayWise];
			// }

			const setItineraryCount = () => {
				let nightCount;
				if (props.count) {
					nightCount = props.count;
				} else if (packageEditState.state?.data?.cities) {
					nightCount = packageEditState.state.data.cities.reduce(
						(previousStay, currentStay) =>
							currentStay.stayNights + previousStay,
						0,
					);
				} else {
					nightCount = masterStore.state.data.package.packageData.cities.reduce(
						(previousStay, currentStay) =>
							currentStay.stayNights + previousStay,
						0,
					);
				}

				if (!nightCount) return;

				const countArray = [];

				for (let i = 0; i <= nightCount; i++) {
					countArray.push(i + 1);
				}

				data.itineraryCount = [...countArray];
			};
			setItineraryCount();

			const formState = reactive({
				isLoading: false,
				disable: true,
			});

			const createItinerary = async () => {
				try {
					let packageData;
					if (packageEditState.state.data) {
						packageData = { ...packageEditState.state.data };
					} else {
						packageData = { ...masterStore.state.data };
					}

					packageData.itineraryDayWise = data.itineraryDayWise;
					await API.privateRequest.post("packages", packageData);
					toast.success(
						{ message: "Package Created!", position: "topRight" },
						true,
					);
					masterStore.methods.changeComponent("table");
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			const disableForm = () => {
				if (data.itineraryCount.length !== data.itineraryDayWise.length) {
					formState.disable = false;
				}
			};

			const enableForm = (itinerary) => {
				delete itinerary.id;
				if (data.itineraryDayWise.length) {
					let filteredData = data.itineraryDayWise.filter(
						(itineraryItem) => itineraryItem.day !== itinerary.day,
					);
					data.itineraryDayWise = [...filteredData, itinerary];
				} else {
					data.itineraryDayWise = [{ ...itinerary }];
				}
				if (data.itineraryCount.length === data.itineraryDayWise.length) {
					formState.disable = false;
					emit("updateItinerary", data.itineraryDayWise);
				}
			};

			return {
				data,
				masterStore,
				packageEditState,
				formState,
				createItinerary,
				disableForm,
				enableForm,
			};
		},
	};
</script>
